import type { BoxProps } from '@mui/material/Box';

import React, { forwardRef } from 'react';
import { Icon } from '@iconify/react';
import Box from '@mui/material/Box';

import type { IconifyProps } from './types';

// ----------------------------------------------------------------------
export type IconifyIconSize = 'large' | 'medium' | 'micro' | 'small' | 'tiny';

export function getIconSize(size: IconifyIconSize) {
  switch (size) {
    case 'tiny':
      return 14;
    case 'small':
      return 20;
    case 'large':
      return 32;
    case 'micro':
      return 8;
    default:
      return 26;
  }
}
interface Props extends BoxProps {
  size: IconifyIconSize;
  icon: IconifyProps;
  width?: number;
}

export const Iconify = forwardRef<SVGElement, Props>(
  ({ height, icon, onClick, size, sx, width: propWidth, ...other }, ref) => {
    const width = getIconSize(size);
    return (
      <Box
        sx={{ height: propWidth || width, width: propWidth || width, ...sx }}
        className="component-iconify"
        onClick={onClick}
        component={Icon}
        icon={icon}
        ref={ref}
        {...other}
      />
    );
  },
);

Iconify.displayName = 'Iconify';

export default React.memo(Iconify);
